module.exports = __webpack_public_path__ + "img/f6a035c.png";